"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRectangle = parseRectangle;
const Util_1 = require("../../Util");
const v6Common_1 = require("./v6Common");
const Utils_1 = require("@cadstrom/sigma-engine-shared/dist/Utils");
function parseRectangle(node, isModule, warnings, defaultLayer, layerSelector, minStrokeWidth = 0) {
    let start = [0, 0];
    let end = [0, 0];
    let strokeWidth = 0;
    let filled;
    let strokeLayer = defaultLayer && layerSelector.getLayerByType(defaultLayer);
    let fillLayer = defaultLayer && layerSelector.getLayerByType(defaultLayer);
    let colorOverride;
    const flipY = isModule ? -1 : 1;
    node.nodes.forEach((n) => {
        switch (n.name) {
            case 'start': {
                start = [parseFloat(n.values[0]), flipY * parseFloat(n.values[1])];
                break;
            }
            case 'end': {
                end = [parseFloat(n.values[0]), flipY * parseFloat(n.values[1])];
                break;
            }
            case 'fill': {
                const fill = (0, v6Common_1.parseFillDirective)(n, layerSelector, defaultLayer);
                filled = fill.filled;
                fillLayer = fill.layer;
                colorOverride = fill.colorOverride;
                break;
            }
            case 'stroke': {
                const widthNode = n.nodes.find((v) => v.name === 'width');
                if (widthNode) {
                    strokeWidth = parseFloat(widthNode.values[0]);
                }
                const typeNode = n.nodes.find((v) => v.name === 'type');
                if (typeNode) {
                    strokeLayer = layerSelector.getLayerByColorType(typeNode.values[0], defaultLayer);
                }
                break;
            }
            case 'layer': {
                if (n.values.length === 1) {
                    strokeLayer = layerSelector.filterLayers((0, Util_1.removeQuotes)(n.values[0]))[0];
                }
                if (n.values.length !== 1 || !strokeLayer) {
                    warnings.push(`Unknow layer configuration for ${node.name}`);
                    if (!strokeLayer) {
                        strokeLayer = defaultLayer && layerSelector.getLayerByType(defaultLayer);
                    }
                }
                break;
            }
        }
    });
    const strokeRect = {
        type: 'rect',
        start,
        end,
        strokeWidth: (0, Utils_1.max)(strokeWidth, minStrokeWidth),
        filled: filled && strokeLayer?.id === fillLayer?.id ? true : undefined,
        colorOverride,
    };
    const shapes = [];
    if (filled && fillLayer && fillLayer.id !== strokeLayer?.id) {
        const fillRect = {
            type: 'rect',
            start,
            end,
            strokeWidth: 0,
            filled: true,
        };
        shapes.push({
            layers: [fillLayer.id],
            drawing: fillRect,
        });
    }
    if (strokeLayer) {
        shapes.push({
            layers: [strokeLayer.id],
            drawing: strokeRect,
        });
    }
    return shapes;
}
//# sourceMappingURL=v6ParseRectangle.js.map